import { SaleModel } from 'api-hooks/sale/common';
import { AuthorizationRules } from 'common/constants';
import { SaleStatusEnum } from 'common/constants/enum';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer, { DrawerProvider } from 'hooks/use-drawer';
import OtherExpenseList from 'legacy-modules/other-expense/list';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function useSalesOtherExpense(data: SaleModel) {
  const { can } = useAuthorization();
  const drawer = useDrawer();
  const { t } = useTranslation();

  const status = data.status;
  const isAllowed = React.useMemo(() => {
    switch (status) {
      case SaleStatusEnum.Refund:
        return false;
      default:
        return true;
    }
  }, [status]);

  const permission = AuthorizationRules.SalesGetOtherExpenses;

  const otherExpensePermission =
    isAllowed && can(permission) && data.transactionType !== 'tour';

  const onOtherExpense = React.useCallback(() => {
    drawer.showCustom({
      render: (onClose) => (
        <DrawerProvider>
          <OtherExpenseList data={data} type="Sale" onClose={onClose} />
        </DrawerProvider>
      ),
    });
  }, [drawer, data]);

  const otherExpenseAction: PopoverMenuType = {
    label: t('common:other_expenses'),
    onClick: onOtherExpense,
    isAllowed: otherExpensePermission,
    isError: false,
    key: `other-expense-${data.id}`,
  };

  return {
    otherExpenseAction,
    otherExpensePermission,
    permission,
    onOtherExpense,
  };
}
